import { UserInfo } from '@/model/common'
import { BjaxEx } from '@bilibili/ogv-yora'
import Mock from '@bilibili/bapi-mock'
import { isDev, isUat, isPre } from '../utils/common'
import { PlayIdResult } from '../model/common'

const http = new BjaxEx()

const prefix = isUat ? 'uat-' : isPre ? 'pre-' : ''
const host = `//${prefix}api.bilibili.com`

let HOST = {
  activity: host,
  common: host,
  fe: 'http://activity.hdslb.com',
}

const { hostname } = location || {}

if (isUat || isDev || hostname === 'localhost') {
  const mock = new Mock()
  HOST = mock.getMockPath(HOST)
}

// eslint-disable-next-line
export const getUserInfo = (): Promise<UserInfo | unknown> => {
  return http.get(
    `${HOST.common}/x/web-interface/nav`,
    {
      ts: new Date().getTime(),
    },
    {
      noErrTip: true,
    }
  )
}

// 获取筛选列表
export const $condition = (params) => {
  return http.get(`${HOST.activity}/pgc/season/index/condition`, {
    t: Date.now(),
    ...params,
  })
}

// 获取筛选结果
export const $getResult = (params) => {
  return http.get(`${HOST.activity}/pgc/season/index/result`, {
    t: Date.now(),
    ...params,
  })
}

// 获取筛选列表
export const $getPlayList = (params) => {
  return http.get(
    `${HOST.activity}/pgc/web/playlist`,
    {
      t: Date.now(),
      ...params,
    },
    { getWholeRes: true }
  )
}

// 获取筛选列表
export const $getPlayIds = (): Promise<PlayIdResult | unknown> => {
  return http.get(
    `${HOST.fe}/blackboard/static/jsonlist/329/value.json`,
    {
      t: Date.now(),
    },
    {
      noErrTip: true,
      withCredentials: false,
    }
  )
}

export default http
